module.exports = __webpack_public_path__ + "static/SZ_hjarta-ebc779c8dc058e2439d5c876bd5a4bba.png";